export default "__VITE_ASSET__DgPUFsl8__"